<template>
  <div class="year-weight-add">
    <el-form
      ref="editForm"
      label-width="130px"
      :model="editJson"
      :rules="rules"
      >
      <el-form-item label="姓名" prop="wkNo">
        <selecter ref="empSelect" v-model="editJson.wkNo" :jobNo="editJson.wkNo" :name="editJson.wkName" :disabled="editData.id"></selecter>
      </el-form-item>
      <el-form-item label="年份" prop="year">
        <el-date-picker
          v-model="editJson.year"
          type="year"
          format="yyyy 年"
          value-format="yyyy"
          placeholder="选择年份"
          style="width: 100%;"
          :disabled="editData.id"
           @change="getClassify"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="期次" prop="period">
        <common-select ref="period" v-model="editJson.period" :list="periodList" optLabel="label" optValue="value" placeholder="期次" :disabled="editData.id" clearable  @change="getClassify"></common-select>
      </el-form-item>
      
      <el-form-item
        v-for="item in classifys"
        :key="item.value"
        :label="item.name"
        :prop="item.field"
      >
        <el-autocomplete
          @change="regScore(item.field)"
          v-model.trim="editJson[item.field]"
         :fetch-suggestions="numberSearch"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" placeholder="请输入备注" maxlength="512" :autosize="{ minRows: 3, maxRows: 5 }" resize="none" v-model="editJson.remarks"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="isEnable" class="algin-left">
        <el-switch
          v-model="editJson.isEnable"
          :inactive-value="0"
          :active-value="1"
        ></el-switch>&nbsp;&nbsp;{{ editJson.isEnable == 1 ? "启用" : "停用" }}
      </el-form-item>
      <el-form-item label-width="0" class="atb-no-margin">
        <div class="atb-text-right">
          <!-- 保存 -->
          <el-button class="atb-dialog-confirm" type="primary" @click="submit">保存</el-button>
          <!-- 取消 -->
          <el-button
            class="atb-dialog-cancel"
            type="cancel"
            @click="$parent.$parent.hide()"
          >取消</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import editMixin from "@/mixins/edit.mixin";
import _ from "lodash";
import { ClASSIFY_LIST } from './yearClassifyList';
import { PERIOD_LIST } from '@/utils/period-enum.js';

export default {
  name: 'YearWeightUpdate',
  components: {
    selecter: () => import('@/component/global/customerSelect'),
  },
  mixins: [editMixin],
  props: {
    // 编辑信息
    editData: {
      type: Object,
      default: () => {}
    },
    editClassifys: {
      type: Object,
      default: () => ([])
    },
  },
  data() {
    return {
      id: "id",
      baseRules: {
        wkNo: [{ required: true, message: '"姓名"为必填项', trigger: "change" }],
        year: [{ required: true, message: '"年份"为必填项', trigger: 'change' }],
        period: [{ required: true, message: '"期次"为必填项', trigger: 'change' }],
      },
      rules: {},
      addApi: this.$api.period.yearWeight.add,
      editApi: this.$api.period.yearWeight.edit,
      editMethod: "post",

      checkId: "",
      checkName: "",
      classifys: [],
      periodList:  _.cloneDeep(PERIOD_LIST),
    };
  },
  watch: {
    'editJson.year': {
      handler(newVal) {
        if (newVal && this.editJson.period) {
          this.getClassify();
        }
      }
    },
    'editJson.period': {
      handler() {
        if (newVal && this.editJson.year) {
          this.getClassify();
        }
      }
    },
  },
  created() {
    this.rules = _.cloneDeep(this.baseRules);
    if (this.editData.id) {
      this.classifys = _.cloneDeep(this.editClassifys);
    } else {
      this.classifys = _.cloneDeep(ClASSIFY_LIST);
    }
    this.classifys.forEach(item => {
      this.rules[item.field] = [
        { required: true, message: `${item.name}为必填项`, trigger: "change" },
      ]
    });
    this.editApi = this.$api.period.yearWeight.edit;
  },
  methods: {
    getClassify() {
      if (this.editJson.year && this.editJson.period) {
        const param = {year: this.editJson.year ? parseInt(this.editJson.year) : undefined, period: this.editJson.period || undefined}
        this.$ajax.post(this.$api.period.yearWeight.getClassify, param).then((res) => {
          const classifys = res.data || [];
          if (classifys && classifys.length > 0) {
            this.classifys = classifys.map(item => {
              return {
                value: item.workClassify,
                name: item.classifyName,
                field: item.classifyNameEn,
                width: 100,
                weight: item.classifyWeight
              }
            })
          } else {
            this.classifys = _.cloneDeep(ClASSIFY_LIST);
          }
          this.rules = _.cloneDeep(this.baseRules);
          this.classifys.forEach(item => {
            this.rules[item.field] = [
              { required: true, message: `${item.name}为必填项`, trigger: "change" },
            ]
          });

          this.$nextTick(() => {
            this.$refs.editForm.clearValidate();
          });
        })
      }
    },
    regScore(field) {
      let val = this.editJson[field];
      if (!val) val = "";
      val = val.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, "$1");
      val = val && parseFloat(val);
      if (val - 0 > 100) {
        val = 100;
      }
      if (val - 0 < 0) {
        val = 0;
      }
      this.editJson[field] = val;
    },
    numberSearch(queryString, cb) {
      let programList = [
        { value: 5 },
        { value: 10 },
        { value: 15 },
        { value: 20 },
        { value: 25 },
        { value: 30 },
        { value: 40 },
        { value: 50 },
        { value: 60 },
        { value: 70 },
        { value: 80 },
        { value: 90 },
        { value: 100 }
      ];
      // 调用 callback 返回建议列表的数据
      cb(programList);
    },
    resetSubmitParams(params) {
      const self = this;
      const resetParam = {
        wkNo: params.wkNo,
        wkName: self.$refs.empSelect.currentOption.name,
        periodClassifyWeightInfos: [],
        isEnable: params.isEnable,
        remarks: params.remarks,
        year: params.year ? parseInt(params.year) : undefined,
        period: params.period
      };
      self.classifys.forEach(item => {
        resetParam.periodClassifyWeightInfos.push({
          workClassify: item.value,
          weight: params[item.field]
        });
      });
      return resetParam;
    },
    
  },
  watch: {
    
  }
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-select, .el-autocomplete {
    width: 100%;
  }
  .algin-left .el-form-item__content {
    text-align: left;
  } 
}
</style>
